import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote, BadgeCheck, ShieldCheck, Eye } from "lucide-react";
import { hoaTestimonials } from "../data/mockData";

const CREDS = [
  { icon: BadgeCheck, label: "Licensed — Texas DPS #B30959201" },
  { icon: ShieldCheck, label: "Fully Insured" },
  { icon: Eye, label: "Dedicated, Always-On Monitoring" },
];

const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = hoaTestimonials[i];
  const next = () => setI((p) => (p + 1) % hoaTestimonials.length);
  const prev = () => setI((p) => (p - 1 + hoaTestimonials.length) % hoaTestimonials.length);

  return (
    <section id="testimonials" className="bg-white py-24 lg:py-32">
      <div className="max-w-5xl mx-auto px-6">
        <div data-reveal className="inline-flex items-center gap-2 mb-10 text-xs font-semibold uppercase tracking-[0.2em] text-[#D32F2F]">
          <span className="w-1.5 h-1.5 rounded-full bg-[#D32F2F]" /> Proven Deterrence
        </div>

        <div data-reveal data-reveal-delay="1" className="rounded-2xl bg-[#F7F7F5] border border-black/5 shadow-ambient p-9 lg:p-14">
          <Quote className="w-10 h-10 text-[#D32F2F] mb-7" />
          <blockquote className="font-head text-2xl lg:text-4xl font-medium text-[#1A1A1A] leading-snug tracking-tight mb-10">
            “{t.content}”
          </blockquote>

          <div className="flex items-center justify-between flex-wrap gap-6 border-t border-black/10 pt-8">
            <div className="border-l-2 border-[#D32F2F] pl-5">
              <div className="font-bold text-[#1A1A1A]">{t.name}</div>
              <div className="text-sm text-[#1A1A1A]/55">{t.role} · {t.community}</div>
            </div>
            <div className="flex items-center gap-3">
              <button onClick={prev} data-testid="testimonial-prev"
                      className="w-11 h-11 rounded-full bg-white border border-black/5 shadow-sm flex items-center justify-center hover:text-[#D32F2F] hover:scale-105 transition-all">
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button onClick={next} data-testid="testimonial-next"
                      className="w-11 h-11 rounded-full bg-white border border-black/5 shadow-sm flex items-center justify-center hover:text-[#D32F2F] hover:scale-105 transition-all">
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        <div data-reveal className="mt-8 flex flex-wrap gap-3">
          {CREDS.map((c) => (
            <div key={c.label} className="inline-flex items-center gap-2.5 rounded-full bg-white border border-black/5 shadow-sm px-5 py-2.5">
              <c.icon className="w-4 h-4 text-[#D32F2F] shrink-0" />
              <span className="text-sm font-medium text-[#1A1A1A]">{c.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
